import { render, staticRenderFns } from "./commentRenderer.vue?vue&type=template&id=6a4915a8&"
import script from "./commentRenderer.vue?vue&type=script&lang=js&"
export * from "./commentRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports